var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3333 0.663692C7.33356 0.749076 7.31629 0.833439 7.28276 0.910584C7.24922 0.987729 7.20027 1.05569 7.13951 1.10949L3.99695 3.86998C3.90323 3.95405 3.78567 4 3.66436 4C3.54304 4 3.42549 3.95405 3.33177 3.86998L0.189209 1.01233C0.0822489 0.915315 0.0149853 0.775912 0.00221614 0.624784C-0.010553 0.473656 0.0322183 0.323183 0.121121 0.206467C0.210023 0.0897505 0.337774 0.0163521 0.47627 0.00241836C0.614766 -0.0115154 0.752662 0.0351566 0.859622 0.132168L3.66698 2.68691L6.47433 0.217897C6.55121 0.148009 6.64483 0.103614 6.74411 0.0899659C6.84338 0.076318 6.94417 0.0939879 7.03453 0.140885C7.12489 0.187783 7.20106 0.261945 7.254 0.354596C7.30695 0.447247 7.33447 0.55451 7.3333 0.663692Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.510b5c5f17cd9bd375fab2e47f4d01b7.svg";
export { ForwardRef as ReactComponent };